import { render, staticRenderFns } from "./EchartsBarTnb.vue?vue&type=template&id=6388b369&scoped=true&"
import script from "./EchartsBarTnb.vue?vue&type=script&lang=js&"
export * from "./EchartsBarTnb.vue?vue&type=script&lang=js&"
import style0 from "./EchartsBarTnb.vue?vue&type=style&index=0&id=6388b369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6388b369",
  null
  
)

export default component.exports